import { render, staticRenderFns } from "./SLSections.vue?vue&type=template&id=54c7adbc&scoped=true&"
import script from "./SLSections.vue?vue&type=script&lang=js&"
export * from "./SLSections.vue?vue&type=script&lang=js&"
import style0 from "./SLSections.vue?vue&type=style&index=0&id=54c7adbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7adbc",
  null
  
)

export default component.exports